import { NavigationTabsOption } from '@common/types/link';
import { useClips } from '@features/Clip';
import { SharedClipTable } from '@features/Clip/components/SharedClipTable';

interface ClipSearchProps {
    tabOptions: NavigationTabsOption<string>[];
    prefix?: string;
}

export const ClipSearchView = ({
    tabOptions,
    prefix = '',
}: ClipSearchProps) => {
    return (
        <SharedClipTable
            queryHook={useClips}
            prefix={prefix}
            size={'1'}
            tabOptions={tabOptions}
            maxRows={'unlimited'}
            configOverrides={{
                selection: {
                    enabled: true,
                    displayKey: 'clipName',
                    summaryKey: 'preservationCategory',
                },
            }}
        />
    );
};
